import { render, staticRenderFns } from "./HistoryEMPage.vue?vue&type=template&id=4cc6453d"
import script from "./HistoryEMPage.vue?vue&type=script&lang=js"
export * from "./HistoryEMPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports